import React from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';

import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import PrivateRoute from '../Components/Hoc/PrivateRoute';
import ValidCpfRoutes from '../Components/Hoc/ValidCpfRoutes';
// Components
import LoginNovo from '../Components/LoginNovo/Login';

import CadastroPerfil from '../Components/CadastroPerfil';
import Home from '../Components/Home/Home';
import PreCadastro from '../Components/PreCadastro';

import Onboarding from '../Components/Onboarding';

import Certificados from '../Components/Certificados';

import Ajuda from '../Components/Atendimento/Ajuda';
import Busca from '../Components/Busca/Busca';
import ConfirmarEmail from '../Components/ConfirmarEmail';
import ConsultaCPF from '../Components/ConsultaCPF';
import ConsultarTermo from '../Components/ConsultarTermo';
import CursoNovo from '../Components/CursoNovo';
import Cursos from '../Components/Cursos';
import EsqueciSenha from '../Components/EsqueciSenha/EsqueciSenha';
import AtualizarSenha from '../Components/AtualizarSenha';
import Eventos from '../Components/Eventos';
import VerifyIE from '../Components/Hoc/onlyVerifyIE';
import RequireAuth from '../Components/Hoc/requireAuth';
import InvoicePaymentHistory from '../Components/InvoicePaymentHistory';
import Logout from '../Components/Logout';
import Maintenance from '../Components/Maintenance';
import NewPayment from '../Components/NewPayment';
import Notificacoes from '../Components/Notificacoes';
import PerfilAluno from '../Components/PerfilAluno/PerfilAluno';
import Recommendations from '../Components/Recommendations';
import RedirectAds from '../Components/RedirectAds';
import CondicoesUso from '../Components/Termos/CondicoesUso';
import Privacidade from '../Components/Termos/Privacidade';
import TesteNivelamento from '../Components/TesteNivelamento/TesteNivelamento';
import Turma from '../Components/Turma';
import Validador from '../Components/Validador';
import WatsonChatPage from '../Components/WatsonChat/WatsonChatPage';
import ApresentacaoCurso from '../Components/CursoNovo/Apresentacao';
import PaymentHistory from '../Components/PaymentHistory';
import Assessment from '../Components/Assessment';
import AssessmentForum from '../Components/AssessmentForum';
import AssessmentView from '../Components/AssessmentView';
import AssessmentWaitingRoom from '../Components/AssessmentWaitingRoom';
import Avaliacao from '../Components/Avaliacao';

import ThankYou from '../Components/ThankYou';
import history from '../utils/history';
import LtiLaunch from '../Components/Lti';
import UpdatedPassword from '../Components/UpdatedPassword'

import FacebookTracking from '../Components/FacebookTracking';
import Teacher from '../Components/CursoNovo/Teacher';
import { CheckAddressOnboarding } from '../Components/CheckAddressOnboarding';
import Library from '../Components/Library';
import MobileVideoVimeo from '../Components/CursoNovo/MobileVideoVimeo';
import TermosExcluirConta from '../Components/Termos/TermosExcluirConta';
import RedirectTotvs from '../Components/RedirectTotvs';
import InformeRendimentos from '../Components/InformeRendimentos';

const Routes = () => (
  <Router history={history}>
    <>
      <CheckAddressOnboarding />
      <FacebookTracking />
      <Switch>
        <Route path="/lti" component={LtiLaunch} />
        <Route exact path="/oauth-plurall" component={VerifyIE(LoginNovo)} />
        <Route exact path="/linkedin" component={LinkedInCallback} />
        <Route exact path="/" component={VerifyIE(LoginNovo)} />
        <Route exact path="/litpass" component={VerifyIE(LoginNovo)} />
        <Route exact path="/vocacao" component={VerifyIE(LoginNovo)} />
        <Route path="/redirect" component={RedirectAds} />
        <PrivateRoute path="/ajuda" component={RequireAuth(Ajuda)} />
        <Route path="/validador" component={VerifyIE(Validador)} />
        <Route path="/consultarTermo" component={VerifyIE(ConsultarTermo)} />
        <Route path="/cadastroPerfil" component={VerifyIE(CadastroPerfil)} />
        <Route
          path="/cadastroPerfilLitPass"
          component={VerifyIE(CadastroPerfil)}
        />
        <Route path="/payment" component={NewPayment} />
        <PrivateRoute
          path="/invoice-payment-history"
          component={InvoicePaymentHistory}
        />
        <Route
          path="/cadastroPerfilVocacao"
          component={VerifyIE(CadastroPerfil)}
        />
        <Route path="/precadastro" component={PreCadastro} />
        <Route path="/esqueciSenha" component={VerifyIE(EsqueciSenha)} />
        <Route path="/atualizar-senha" component={VerifyIE(AtualizarSenha)} />
        <Route path="/cadastrar-senha" component={VerifyIE(AtualizarSenha)} />
        <Route path="/confirmarEmail" component={VerifyIE(ConfirmarEmail)} />
        <Route path="/consultaCpf" component={VerifyIE(ConsultaCPF)} />
        <ValidCpfRoutes path="/planos" component={VerifyIE(NewPayment)} />
        <Route path="/logout" component={VerifyIE(Logout)} />
        <Route path="/manutencao" component={VerifyIE(Maintenance)} />
        <Route
          path="/vitrine/curso/:idCurso"
          render={props => (
            <Redirect to={`/curso/${props.match.params.idCurso}`} />
          )}
        />
        <PrivateRoute
          path="/updated-password"
          component={RequireAuth(UpdatedPassword)}
        />
        <PrivateRoute
          path="/historico-de-pagamento"
          component={RequireAuth(PaymentHistory)}
        />
        <PrivateRoute path="/home" component={RequireAuth(Home)} />
        <PrivateRoute path="/cursos" component={RequireAuth(Cursos)} />
        <PrivateRoute
          path="/certificados"
          component={RequireAuth(Certificados)}
        />
        
        <PrivateRoute path="/curso-novo/:idCurso" component={CursoNovo} />
        <PrivateRoute
          path="/apresentacao-do-curso/:courseCrCode/:lockedCourse"
          component={RequireAuth(ApresentacaoCurso)}
        />
        <PrivateRoute
          path="/professor/:teacherCrCode"
          component={RequireAuth(Teacher)}
        />
        <PrivateRoute path="/onboarding" component={RequireAuth(Onboarding)} />
        <PrivateRoute path="/avaliacao" component={RequireAuth(Avaliacao)} />
       
        <PrivateRoute
          path="/notificacoes"
          component={RequireAuth(Notificacoes)}
        />
        <PrivateRoute
          path="/chatPaul"
          component={RequireAuth(WatsonChatPage)}
        />
        <PrivateRoute
          path="/testeNivelamento"
          component={RequireAuth(TesteNivelamento)}
        />
        <PrivateRoute
          path="/perfilAluno"
          component={RequireAuth(PerfilAluno)}
        />
        <PrivateRoute path="/busca" component={RequireAuth(Busca)} />
        {/* TODO: Remover o Turma quando o novo projeto estiver pronto */}
        {/* <PrivateRoute path="/turma/:code" component={RequireAuth(Turma)} /> */}
        <PrivateRoute
          path="/recommendations"
          component={RequireAuth(Recommendations)}
        />
        <PrivateRoute path="/eventos" component={RequireAuth(Eventos)} />
        <PrivateRoute
          path="/library"
          component={Library}
        />
        <PrivateRoute
          path="/redirect-totvs"
          component={RedirectTotvs}
        />
        <Route path="/termos-condicoes-uso" component={CondicoesUso} />
        <Route path="/assessment" component={Assessment} />
        <Route
          path="/assessment-waiting-room"
          component={AssessmentWaitingRoom}
        />
        <Route path="/assessment-view" component={AssessmentView} />
        <Route path="/assessment-forum" component={AssessmentForum} />
        <Route path="/politica-privacidade" component={Privacidade} />
        <Route path="/instrucoes-exclusao-conta" component={TermosExcluirConta} />
        <Route path="/informe-rendimentos/:cpf/:hash" component={InformeRendimentos} />
        <Route path="/sucesso_:plan" component={ThankYou} />
        <Route path="/mobile-video-vimeo" component={MobileVideoVimeo} />
        <Route path="*" exact component={VerifyIE(LoginNovo)} />
      </Switch>
    </>
  </Router>
);

export default Routes;
